const thresholdSettings = {
  correctMsFloor: 100,
  incorrectMsFloor: 120,
  correctBeatDivision: .29,
  incorrectBeatDivision: .38,
};

export default thresholdSettings;